import * as Sentry from "@sentry/nextjs";

export const logToSentry = (
  error: Error,
  tags: [string, string][],
  extras?: Record<string, unknown>,
) => {
  Sentry.withScope((scope) => {
    tags.forEach(([key, value]) => scope.setTag(key, value));
    if (extras) {
      Object.entries(extras).forEach(([key, value]) =>
        scope.setExtra(key, value),
      );
    }
    Sentry.captureException(error);
  });
};
